import styled from 'styled-components/macro';

export const ProtectedImg = styled.img`
  max-width: 100%;
  height: auto;
`;
